// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";
import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";
// images
import blogsImg1 from "../images/blog/blog-single/img-1.jpg";
import blogsImg2 from "../images/blog/blog-single/img-2.jpg";
import blogsImg3 from "../images/blog/blog-single/img-3.jpg";
import blogsImg4 from "../images/blog/blog-single/img-4.jpg";
import blogsImg5 from "../images/blog/blog-single/img-5.jpg";
import blogsImg6 from "../images/blog/blog-single/img-6.jpg";


const blogs = [
    {
        id: '1',
        title: '10 Reasons why you should make a physical portfolio',
        slug:'10-Reasons-why-you-should-make-a-physical-portfolio',
        screens: blogImg1,
        bSingle: blogsImg1,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Marilou Kelleher',
        authorTitle:'Sineor Consultant',
        create_at: 'October 25, 2023',
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'A Day in the Life: Cool and Exteriors',
        slug:'A-Day-in-the-Life-Cool-and-Exteriors',
        screens: blogImg2,
        bSingle: blogsImg2,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: 'October 23, 2023',
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'Increasing productivity through workplace friends',
        slug: 'Increasing-productivity-through-workplace-friends',
        screens: blogImg3,
        bSingle: blogsImg3,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: 'October 15, 2023',
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '4',
        title: '10 Reasons why you should make a physical portfolio',
        slug: '10-Reasons-why-you-should',
        screens: blogImg4,
        bSingle: blogsImg4,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: 'October 15, 2023',
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '5',
        title: 'Increasing productivity through workplace friends',
        slug: 'Increasing-productivity-through',
        screens: blogImg5,
        bSingle: blogsImg5,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: 'October 15, 2023',
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '6',
        title: 'Increasing productivity through workplace friends',
        slug: 'productivity-through-workplace-friends',
        screens: blogImg6,
        bSingle: blogsImg6,
        description: 'Use high-quality images and videos to create a visually appealing experience. Visuals of happy clients can significantly...',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: 'October 15, 2023',
        comment:'95',
        blClass:'format-video',
    },
];
export default blogs;